import { combineReducers } from 'redux';

import list from './list';
import adjustCredit from './adjustCredit';
import transferCredit from './transferCredit';

export default combineReducers({
  list,
  adjustCredit,
  transferCredit,
});
